<template>
  <span class="select-actions">
    <span v-if="select">
      <v-layout>
        <v-row>
          <v-col>
            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item-group>
                  <router-link
                    :to="{
                      name: 'Select',
                      query: {
                        view: select.query_id,
                      },
                    }"
                  >
                    <v-list-item>
                      <v-list-item-icon>
                        <v-icon> mdi-file-find </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Run Select</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </router-link>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-layout>
    </span>
  </span>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    select: Object,
    show_details: {
      type: Boolean,
      default: false,
    },
    show_users: {
      type: Boolean,
      default: false,
    },
    show_usage: {
      type: Boolean,
      default: false,
    },
    show_orders: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["user_details", "account_details"]),

    can_view_users() {
      return (
        this.user_details.super_admin ||
        (this.user_details.account_id === this.account.account_id &&
          this.user_details.admin) ||
        (this.user_details.support_accounts &&
          this.user_details.support_accounts.includes(this.account.account_id))
      );
    },
  },
};
</script>
